// A hand-built KPI card matching the current app's HTML cards (app/dashboard.py).
interface Props {
  label: string;
  value: string;
  accent?: "primary" | "success" | "risk" | "warn";
  note?: string;
}

export default function KpiCard({ label, value, accent, note }: Props) {
  const color = accent ? `var(--${accent})` : "var(--text-dark)";
  return (
    <div className="col kpi-card">
      <div className="kpi-label">{label}</div>
      <div className="kpi-value" style={{ color }}>{value}</div>
      {note && <div className="kpi-note">{note}</div>}
    </div>
  );
}

// AED money formatter mirroring utils.fmt_aed (thousands separators, 2dp,
// parentheses for negatives is handled by the caller where needed).
export function fmtAed(v: number | undefined | null): string {
  if (v === undefined || v === null || Number.isNaN(v)) return "—";
  return v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
